/**
 * Plain-text empty / loading / error state for the resource list region.
 *
 * Task 3.2 — visuals are intentionally bare per the task plan
 * ("just plain text one below other (no design implemented yet)").
 * Task 3.5 will replace this with the proper visual treatment.
 */

import { Box, Typography, useTheme } from "@mui/material";

interface EmptyStateProps {
  message: string;
}

export const EmptyState = ({ message }: EmptyStateProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: "16px",
        px: "16px",
      }}
    >
      <Typography
        variant="body-medium"
        sx={{ color: theme.palette.lightBg.medium }}
      >
        {message}
      </Typography>
    </Box>
  );
};
